<template>
  <div class="page">
    <div class="news">
      <div class="newsTitle">{{ props.data.titleCn }}</div>
      <div class="newsEn">{{ props.data.titleEn }}</div>
    </div>
    <div class="newsList">
      <div class="list-item" @click="jumpLink(item.linkUrl)" v-for="(item,index) in props.data.list" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-desc van-multi-ellipsis--l3">{{item.desc}}</div>
          <div class="item-btn">
            <div class="item-time">{{item?.time}}</div>
            <img src="https://p2.ssl.qhimg.com/t110b9a93015d582d6db1af5e56.png" alt="">
          </div>
      </div>
    </div>
    <div class="newsMore">
      <img src="https://s0.ssl.qhres2.com/static/82ce48585b1cdb35.svg" @click="jumpLink(props.data.jumpMore)" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const jumpLink = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}

</script>

<style lang="scss" scoped>
.page{
  opacity: 1;
  padding: 72px 20px 0;
  .news {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    &Title {
      color: rgb(44, 44, 44);
      font-family: Source Han Sans;
      font-size: 32px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0px;
      text-transform: uppercase;
    }
    &En {
      color: rgb(44, 44, 44);
      font-family: Rubik;
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0px;
      text-transform: uppercase;
      margin-top: 12px;
    }
  }
  .newsList {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 32px;
    .list-item {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-radius: 12px;
      background: rgb(255, 255, 255);
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.15);
      margin-bottom: 14px;
      padding: 28px;
      .item-title{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
        padding-bottom: 12px;
        border-bottom: 0.5px solid rgb(177, 176, 176);
      }
      .item-desc{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: justify;
        text-transform: uppercase;
        margin-top: 12px;
      }
      .item-btn{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .item-time{
          color: rgb(177, 176, 176);
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
        img{
          height: 16px;
        }
      }
    }
  }
  .newsMore{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-top: 20px;
    img{
      width: 260px;
    }
  }
}
</style>
